import React, { FC } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { EvLinkNavigationTabs } from '@evinced-private/ui-common';

import { RoutesHelper } from 'src/common/helpers/RoutesHelper';

import { useBusinessUnitLabelDisplayName } from '../../helpers/BusinessUnitLabelHelper';
import {
	createDashboardTabOptions,
	getActiveTabFromPath
} from '../../helpers/TabNavigationHelpers';
import { DashboardType } from '../../types/DashboardType';
import { DashboardTabId } from '../../types/DashboardTypes';

export const DashboardTabsNav: FC = () => {
	const history = useHistory();
	const { pathname } = useLocation();
	const businessUnitDisplayName = useBusinessUnitLabelDisplayName();

	const dashboardType: DashboardType = pathname.startsWith(
		RoutesHelper.getMobileAccessibilityDashboardPath()
	)
		? 'mobile'
		: 'web';

	const activeTabId = pathname.startsWith(RoutesHelper.getMobileBusinessUnitDashboardPath())
		? DashboardTabId.BUSINESS_UNITS
		: getActiveTabFromPath(pathname);
	const options = createDashboardTabOptions(history, businessUnitDisplayName, dashboardType);

	return <EvLinkNavigationTabs selectedTabId={activeTabId} options={options} />;
};
